
import React from 'react';
import logo from '../Jamboree_2026_logo_BC.svg';
import { Button } from '@progress/kendo-react-buttons';

export const Unauthorized=()=>{
    return(
        <div className="App">
        <header className="App-header">
            <img src={logo} className="App-logo" alt="logo" />
            <div style={{padding:"10px"}}>
            <p>
            Sorry. This device is not authorized<br/>to use this application.
            </p>
            <p>Please scan you authentication code to continue.</p>
            <a href='/BigBoard'>Program Status</a>

            <a href='/BigBoard'>Program Status</a>
            </div>
        </header>
        </div>
    )
}